// Browser notifications. Permission is requested only from a user gesture (first pointerdown).

let onClick: ((sid: number) => void) | null = null;

export function setNotificationClickHandler(fn: (sid: number) => void) {
  onClick = fn;
}

export function installPermissionRequest() {
  if (typeof Notification === 'undefined' || Notification.permission !== 'default') return;
  const ask = () => {
    removeEventListener('pointerdown', ask, true);
    if (Notification.permission === 'default') {
      Notification.requestPermission().catch(() => {});
    }
  };
  addEventListener('pointerdown', ask, true);
}

const HERE = 'cmx.notify.here';
const hereListeners = new Set<() => void>();

/** "Notifications · On this computer" (Settings): this browser's own choice, on unless turned off. */
export function notifyHere(): boolean {
  try {
    return localStorage.getItem(HERE) !== 'off';
  } catch {
    return true;
  }
}

export function setNotifyHere(on: boolean) {
  try {
    localStorage.setItem(HERE, on ? 'on' : 'off');
  } catch {
    /* private window: for this visit only */
  }
  if (on && typeof Notification !== 'undefined' && Notification.permission === 'default') Notification.requestPermission().catch(() => {});
  hereListeners.forEach((f) => f());
}

export function onNotifyHere(f: () => void) {
  hereListeners.add(f);
  return () => void hereListeners.delete(f);
}

export function notifyBrowser(title: string, body: string, sid: number) {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted' || !notifyHere()) return;
  try {
    const n = new Notification(title, { body, tag: `cmx-session-${sid}` });
    n.onclick = () => {
      window.focus();
      onClick?.(sid);
      n.close();
    };
  } catch {
    // Some platforms only allow notifications from a service worker; the in-app toast suffices.
  }
}
